import React, {useContext} from 'react';
import ExchangeList from './ExchangeList';
import {SheetContext} from "../../context";
import TabNavBar from "../../components/TabNavBar";

export function ExchangeScreen({data, isLoading}) {
  return <>
    <ExchangeList data={data}
                  isLoading={isLoading}/>
    <TabNavBar value="exchanges"/>
  </>;
}
export default function ExchangeScreenWrapper(params) {
  const {exchanges, exchangesLoading} = useContext(SheetContext);

  return <ExchangeScreen
    data={exchanges}
    isLoading={exchangesLoading}/>
}
